import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import i18n from '../i18n';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://lionmagazine-backend-139572186833.asia-southeast1.run.app/api';

const ShareLinkLoginPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    i18n.changeLanguage('zh');
    localStorage.setItem('i18nextLng', 'zh');

    const linkToken = searchParams.get('token');
    const next = searchParams.get('next') || '/';

    if (!linkToken) {
      setError('登入失敗：連結無效或已過期。');
      return;
    }

    axios.post(`${API_BASE_URL}/auth/share-link-login/`, { token: linkToken })
      .then(({ data }) => {
        localStorage.setItem('auth_token', data.token);
        localStorage.setItem('auth_user', JSON.stringify({
          id: data.id,
          username: data.username,
          email: data.email,
          is_staff: data.is_staff,
          is_superuser: data.is_superuser,
        }));
        navigate(next, { replace: true });
      })
      .catch((err) => {
        const msg = err.response?.data?.detail || '登入失敗：連結無效或已被撤銷。';
        setError(msg);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center', color: '#dc2626' }}>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <p style={{ color: '#64748b' }}>登入中，請稍候…</p>
    </div>
  );
};

export default ShareLinkLoginPage;
